export function Loader() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white dark:bg-black">
      <img src="/logo.svg" alt="Outpost9" className="h-12 w-auto" />
      <div className="mt-6 h-1 w-48 overflow-hidden rounded-full bg-slate-100 dark:bg-black">
        <div className="h-full w-1/3 animate-slide rounded-full bg-accent" />
      </div>
    </div>
  );
}
